import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import { Location } from '~commonInfra/utils/Location';
import { Set } from '~commonInfra/utils/Set';
import { AddGroupsToGroupSet, DeleteGroupSets, EditGroupSet, GroupSetRemoveGroups } from '~src/bootstrap/redux/actions/AppActionTypes';
import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { ToasterService } from '~src/commonInfra/services/ToasterService';
import { reloadSpace } from '~src/spacesPlatform/sagas/content/RefreshContentSagas';

import { GroupSetAddGroupsAction, GroupSetEditAction, GroupSetRemoveGroupsAction,GroupSetsDeleteAction } from '../actions/GroupSetMenuActions';
import { IGroupSetGroupInfo, IGroupSetInfo } from '../models/IGroupSetInfo';
import { AddGroupsToGroupSetAction } from '../services/actions/AddGroupsToGroupSetAction';
import { DeleteGroupSetAction } from '../services/actions/DeleteGroupSetAction';
import { EditGroupSetDialogAction } from '../services/actions/EditGroupSetDialogAction';
import { RemoveGroupsFromGroupSetAction } from '../services/actions/RemoveGroupsFromGroupSetAction';



export function deleteGroups(groupSets: IGroupSetInfo[]) {
    return DeleteGroupSetAction.showDeleteGroupSetDialog(Set.fromIdItemArray(groupSets)).then(() => {
      ToasterService.instance.markToastsAsDoNotDismissOnLocationChange();
      const siteUrls = siteUrlsSelector(getAppStore().getState());
      Location.instance.setUrl(siteUrls.groupSetsUrl());
    });
}

export function* handleDeleteGroupSets(action: GroupSetsDeleteAction): SagaIterator {
    try {
        yield call(deleteGroups, action.groupSets);
        yield call(reloadSpace);
    } catch (e) {
        yield put(requestFailed(e, Messages.errorUnknown()));
    }
}

export function removeGroupsFromGroupSet(groups: IGroupSetGroupInfo[]) {
    return RemoveGroupsFromGroupSetAction.showRemoveGroupsFromGroupSetDialog(Set.fromIdItemArray(groups)).then(() => {
        ToasterService.instance.markToastsAsDoNotDismissOnLocationChange();
    });
}

export function* handleGroupSetRemoveGroups(action: GroupSetRemoveGroupsAction): SagaIterator {
    try {
        yield call(removeGroupsFromGroupSet, action.groups);
        yield call(reloadSpace);
    } catch (e) {
        yield put(requestFailed(e, Messages.errorUnknown()));
    }
}

export function editGroupSet(groupSet: IGroupSetInfo) {
    return EditGroupSetDialogAction.showEditGroupSetDialog(groupSet);
}

 export function* handleEditGroupSet(action: GroupSetEditAction): SagaIterator {
    try {
      yield call(editGroupSet, action.groupSet);
      yield call(reloadSpace);
    } catch (e) {
      yield put(requestFailed(e, Messages.errorUnknown()));
    }
}

export function addGroupsToGroupSet(groupSet: IGroupSetInfo) {
    return AddGroupsToGroupSetAction.showAddGroupsToGroupSetDialog(groupSet);
}

export function* handleAddGroupsToGroupSet(action: GroupSetAddGroupsAction): SagaIterator {
    try {
      yield call(addGroupsToGroupSet, action.groupSet);
      yield call(reloadSpace);
    } catch (e) {
      yield put(requestFailed(e, Messages.errorUnknown()));
    }
}

export function* rootGroupSetMenuActionSaga(): SagaIterator {
    yield takeEvery(DeleteGroupSets, handleDeleteGroupSets);
    yield takeEvery(EditGroupSet, handleEditGroupSet);
    yield takeEvery(GroupSetRemoveGroups, handleGroupSetRemoveGroups);
    yield takeEvery(AddGroupsToGroupSet, handleAddGroupsToGroupSet);
}